const URL = process.env.REACT_APP_URL;

const pointOptions = [{ label: 'Revenue', value: 'Revenue' }];

const sizeOptions = [
  { value: 'SM', label: 'Small' },
  { value: 'M', label: 'Medium' },
  { value: 'L', label: 'Large' },
  { value: 'XL', label: 'Extra Large' },
];

const dateOptions = [
  { label: 'Yearly', value: 'Yearly' },
  { label: 'Monthly', value: 'Monthly' },
];

const subscriptionOptions = [
  {
    value: 'BPO Active Listing Agent',
    label: 'BPO Active Listing Agent',
  },
  {
    value: 'BPO Deal Analyzer',
    label: 'BPO Deal Analyzer',
  },
  {
    value: 'BPO Farm Agent',
    label: 'BPO Farm Agent',
  },
  {
    value: 'BPO Premier Agent',
    label: 'BPO Premier Agent',
  },
];

const professionalOptions = [
  { value: 'Real Estate Agent', label: 'Real Estate Agent' },
  { value: 'Investor', label: 'Investor' },
  { value: 'Home Improvement Services', label: 'Home Improvement Services' },
  { value: 'Photographer', label: 'Photographer' },
  { value: 'Home Builder', label: 'Home Builder' },
  { value: 'Home Inspector', label: 'Home Inspector' },
  { value: 'Property Manager', label: 'Property Manager' },
  {
    value: 'Other Real Estate Professional',
    label: 'Other Real Estate Professional',
  },
];

const states = [
  {
    label: 'Alabama',
    value: 'AL',
  },
  {
    label: 'Alaska',
    value: 'AK',
  },
  {
    label: 'American Samoa',
    value: 'AS',
  },
  {
    label: 'Arizona',
    value: 'AZ',
  },
  {
    label: 'Arkansas',
    value: 'AR',
  },
  {
    label: 'California',
    value: 'CA',
  },
  {
    label: 'Colorado',
    value: 'CO',
  },
  {
    label: 'Connecticut',
    value: 'CT',
  },
  {
    label: 'Delaware',
    value: 'DE',
  },
  {
    label: 'District Of Columbia',
    value: 'DC',
  },
  {
    label: 'Federated States Of Micronesia',
    value: 'FM',
  },
  {
    label: 'Florida',
    value: 'FL',
  },
  {
    label: 'Georgia',
    value: 'GA',
  },
  {
    label: 'Guam',
    value: 'GU',
  },
  {
    label: 'Hawaii',
    value: 'HI',
  },
  {
    label: 'Idaho',
    value: 'ID',
  },
  {
    label: 'Illinois',
    value: 'IL',
  },
  {
    label: 'Indiana',
    value: 'IN',
  },
  {
    label: 'Iowa',
    value: 'IA',
  },
  {
    label: 'Kansas',
    value: 'KS',
  },
  {
    label: 'Kentucky',
    value: 'KY',
  },
  {
    label: 'Louisiana',
    value: 'LA',
  },
  {
    label: 'Maine',
    value: 'ME',
  },
  {
    label: 'Marshall Islands',
    value: 'MH',
  },
  {
    label: 'Maryland',
    value: 'MD',
  },
  {
    label: 'Massachusetts',
    value: 'MA',
  },
  {
    label: 'Michigan',
    value: 'MI',
  },
  {
    label: 'Minnesota',
    value: 'MN',
  },
  {
    label: 'Mississippi',
    value: 'MS',
  },
  {
    label: 'Missouri',
    value: 'MO',
  },
  {
    label: 'Montana',
    value: 'MT',
  },
  {
    label: 'Nebraska',
    value: 'NE',
  },
  {
    label: 'Nevada',
    value: 'NV',
  },
  {
    label: 'New Hampshire',
    value: 'NH',
  },
  {
    label: 'New Jersey',
    value: 'NJ',
  },
  {
    label: 'New Mexico',
    value: 'NM',
  },
  {
    label: 'New York',
    value: 'NY',
  },
  {
    label: 'North Carolina',
    value: 'NC',
  },
  {
    label: 'North Dakota',
    value: 'ND',
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MP',
  },
  {
    label: 'Ohio',
    value: 'OH',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    label: 'Oregon',
    value: 'OR',
  },
  {
    label: 'Palau',
    value: 'PW',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    label: 'Puerto Rico',
    value: 'PR',
  },
  {
    label: 'Rhode Island',
    value: 'RI',
  },
  {
    label: 'South Carolina',
    value: 'SC',
  },
  {
    label: 'South Dakota',
    value: 'SD',
  },
  {
    label: 'Tennessee',
    value: 'TN',
  },
  {
    label: 'Texas',
    value: 'TX',
  },
  {
    label: 'Utah',
    value: 'UT',
  },
  {
    label: 'Vermont',
    value: 'VT',
  },
  {
    label: 'Virgin Islands',
    value: 'VI',
  },
  {
    label: 'Virginia',
    value: 'VA',
  },
  {
    label: 'Washington',
    value: 'WA',
  },
  {
    label: 'West Virginia',
    value: 'WV',
  },
  {
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    label: 'Wyoming',
    value: 'WY',
  },
];

//array of time zones in usa

const timeZones = [
  {
    value: 'Eastern Time Zone',
    label: 'Eastern Time Zone',
  },
  {
    value: 'Hawaii Time Zone',
    label: 'Hawaii Time Zone',
  },
  {
    value: 'Mountain Time Zone',
    label: 'Mountain Time Zone',
  },
  {
    value: 'Central Time Zone',
    label: 'Central Time Zone',
  },
  {
    value: 'Atlantic Time Zone',
    label: 'Atlantic Time Zone',
  },
  {
    value: 'Pacific Time Zone',
    label: 'Pacific Time Zone',
  },
  {
    value: 'Alaska Time Zone',
    label: 'Alaska Time Zone',
  },
];

const officeLocations = [
  {
    value: 'Southern Ca',
    label: 'Southern Ca',
  },
  {
    value: 'Northern Ca',
    label: 'Northern Ca',
  },
];

const marketerOptions = [
  { label: 'US Marketer', value: 'us_agent' },
  { label: 'International Marketer', value: 'international' },
];

export {
  professionalOptions,
  dateOptions,
  states,
  timeZones,
  URL,
  pointOptions,
  subscriptionOptions,
  sizeOptions,
  officeLocations,
  marketerOptions,
};
